module.exports = __webpack_public_path__ + "img/xk.3e793eab.svg";